@if (!isInline) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button fill="clear" color="dark" mode="ios" (click)="dismiss()">
          {{ 'BUTTON.CANCEL' | translate }}
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button fill="clear" color="dark" mode="ios" (click)="save('apply')" [disabled]="!filterForm.dirty || filterForm.invalid">
          {{ 'BUTTON.SAVE' | translate }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
}

<div [class.modal-content]="!isInline">
  <div class="proto-content proto-input-form"
    [formGroup]="filterForm">

    @for (list of formFieldLists; track list.id) {
      <ion-list class="proto-input-list" inset>
        @for (item of list.items; track item.id) {

          <!-- this should always be true -->
          @if (list.type !== 'dynamic') {
            @let control = asFormControl(item.id);
            <proto-form-field
              [control]="control"
              [field]="item"
              (valueUpdated)="onValueUpdated($event, item)"
              (openModal)="openModal($event)"></proto-form-field>
          }
        }
      </ion-list>
    }

    <div class="filter-footer">
      <ion-button class="proto-button reset-button" size="small" fill="clear" color="medium"
        (click)="save('reset')">
        {{'BUTTON.RESET_FILTER' | translate }}
      </ion-button>
    </div>
  </div>
</div>
